import { format } from "util";

// Cria a função de handleRow genérica
export function createHandleRow(record, rowIndex, onRow) {
  const fn = typeof onRow === "function" ? onRow(record, rowIndex) : {};
  return {
    onClick: (event) => {
      if (typeof fn?.onClick === "function") fn.onClick(event);
      else event.currentTarget.classList.toggle("focused");
    },
    onDoubleClick: (event) => fn?.onDoubleClick?.(event),
    onContextMenu: (event) => fn?.onContextMenu?.(event),
    onMouseEnter: (event) => fn?.onMouseEnter?.(event),
    onMouseLeave: (event) => fn?.onMouseLeave?.(event),
  };
}

// Cria a função showTotal para o componente Table
export function showTotalWithSelection(t, rowSelection) {
  return (total, range) => {
    let message =
      total === 1
        ? format(t("exibindo %d item"), total)
        : format(t("exibindo %d-%d de %d itens"), range[0], range[1], total);

    const selecionados = rowSelection?.selectedRowKeys?.length ?? 0;
    if (selecionados === 1) message = format(t("%d selecionado, %s"), selecionados, message);
    else if (selecionados > 1) message = format(t("%d selecionados, %s"), selecionados, message);

    return message;
  };
}